"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Other16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { clipPath: "url(#clip0_2063_49)" },
            react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.843993 12C0.465177 12 0.223953 11.5951 0.404273 11.262L6.06029 0.812395C6.24937 0.463068 6.75065 0.463068 6.93973 0.812394L9.82301 6.13932C10.2005 6.04825 10.5946 6 11 6C13.7614 6 16 8.23858 16 11C16 13.7614 13.7614 16 11 16C8.58104 16 6.56329 14.2822 6.10002 12H0.843993ZM8.17071 12C8.58254 13.1652 9.69378 14 11 14C12.6569 14 14 12.6569 14 11C14 9.34315 12.6569 8 11 8C10.9438 8 10.888 8.00154 10.8326 8.00459L12.5957 11.262C12.7761 11.5951 12.5348 12 12.156 12H8.17071ZM8.97947 8.78244L9.63849 10H8.1707C8.33715 9.52908 8.61784 9.11213 8.97947 8.78244ZM8.01031 6.99191C7.04476 7.71329 6.3486 8.77538 6.10002 10H3.36152L6.50001 4.20159L8.01031 6.99191Z", fill: "#383F49" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0_2063_49" },
                react_1.default.createElement("rect", { width: 16, height: 16, fill: "white" }))));
}
function Other16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Other16Svg, Object.assign({}, svgProps)));
}
exports.default = Other16;
//# sourceMappingURL=Other16.js.map